import React from 'react';
import { HOME_LOANS_HOW_TO_REFINANCE_MORTGAGE } from 'types/morph.pagePosition.constants';
import { useViewModule, useSeenModulePixel } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import HomeMortgageRefinanceModuleView from './HomeMortgageRefinanceModuleView';

const HomeMortgageRefinanceModuleController = props => {
  const trackingAtr = getViewModuleTrackingAttributes(
    HOME_LOANS_HOW_TO_REFINANCE_MORTGAGE,
    props.modulePosition,
  );

  const loading = props.globalLoadingFlag;

  useViewModule(trackingAtr, !loading);

  const seenModuleTracking = useSeenModulePixel(trackingAtr);

  return (
    <>
      {seenModuleTracking}
      <HomeMortgageRefinanceModuleView {...props} />
    </>
  );
};

export default HomeMortgageRefinanceModuleController;
